import React, { useState, useEffect } from 'react';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

const MySwal = withReactContent(Swal);

const Settings = () => {
    const echoUser = localStorage.getItem("echo_user");
    const [name, setName] = useState('');
    const [bio, setBio] = useState('');
    const [avatar, setAvatar] = useState('');
    const [preview, setPreview] = useState('');

    useEffect(() => {
        const fetchData = async () => {
            try {
                const res = await fetch("https://api.fantasyworldtrpg.cz/echo/profile.php", {
                    method: "POST",
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ id: echoUser })
                });
                const data = await res.json();
                if (data.status === 'success') {
                    setName(data.user.display_name);
                    setBio(data.user.bio || '');
                    setAvatar(data.user.avatar || '');
                    setPreview(data.user.avatar || '');
                }
            } catch (err) {
                console.error(err);
            }
        };

        fetchData();
    }, [echoUser]);

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setPreview(URL.createObjectURL(file));
            uploadToImgur(file);
        }
    };

    const uploadToImgur = async (file) => {
        const formData = new FormData();
        formData.append("image", file);

        try {
            const res = await fetch("https://api.imgur.com/3/image", {
                method: "POST",
                headers: {
                    Authorization: "Client-ID 802dc556f40f25f"
                },
                body: formData
            });

            const data = await res.json();
            if (data.success) {
                setAvatar(data.data.link);
            } else {
                throw new Error("Nahrání selhalo");
            }
        } catch (err) {
            console.error("Chyba při nahrávání obrázku:", err);
            await MySwal.fire("Chyba", "Nepodařilo se nahrát fotku.", "error");
        }
    };

    const handleSave = async () => {
        try {
            const res = await fetch("https://api.fantasyworldtrpg.cz/echo/update_profile.php", {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    id: echoUser,
                    name,
                    bio,
                    avatar
                })
            });

            const data = await res.json();
            if (data.status === "success") {
                await MySwal.fire("Hotovo!", "Profil byl aktualizován.", "success");
            } else {
                throw new Error();
            }
        } catch (err) {
            console.error(err);
            await MySwal.fire("Chyba", "Nepodařilo se uložit změny.", "error");
        }
    };

    return (
        <div className="container py-5 my-5">
            <h2 className="mb-4">⚙️ Nastavení profilu</h2>

            <div className="mb-3">
                <label className="form-label">Profilová fotka</label><br/>
                {preview && (
                    <img src={preview} alt="Preview" style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', marginBottom: 10 }} />
                )}
                <input type="file" className="form-control" onChange={handleImageChange} />
            </div>

            <div className="mb-3">
                <label className="form-label">Jméno</label>
                <input type="text" className="form-control" value={name} onChange={(e) => setName(e.target.value)} />
            </div>

            <div className="mb-3">
                <label className="form-label">Bio</label>
                <textarea className="form-control" rows="3" value={bio} onChange={(e) => setBio(e.target.value)}></textarea>
            </div>

            <button className="btn btn-danger w-100" onClick={handleSave}>
                💾 Uložit změny
            </button>
        </div>
    );
};

export default Settings;
